import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Dropzone from 'react-dropzone';
import './style.scss';

class FileAttach extends Component {
    onDrop = (acceptedFiles) => {
        const {onChange, onError} = this.props;
        // do stuff with files...
        if (acceptedFiles.length) {
            onChange(acceptedFiles);
        } else {
            onError();
        }
    };

    open = () => {
        if (this.node) {
            this.node.open();
        }
    }

    ref = (node) => {
        this.node = node;
    }

    render() {
        const {fileExtension, style, className, onCancel, multiple = true} = this.props;
        return (
            <Dropzone
                ref={this.ref}
                accept={fileExtension}
                multiple={multiple}
                disableClick={this.props.disabled}
                disabled={this.props.disabled}
                onClick={this.props.onClick}
                onDrop={this.onDrop}
                style={{width: '100%', height: 'auto', ...style}}
                onFileDialogCancel={onCancel}
                className={`attachment-block ${className || ''}`}
            >
                {this.props.children}
            </Dropzone>
        );
    }
}

FileAttach.propTypes = {
    onChange: PropTypes.func.isRequired,
    className: PropTypes.string,
    children: PropTypes.element.isRequired,
    style: PropTypes.object,
};

export default FileAttach;
